import type { ServerPaginationConfig } from '@shared/types/module-config';

export const CASHOUT_PAGINATION: ServerPaginationConfig = {
  enabled: true,
  mode: 'server',
  pageParam: 'page',
  sizeParam: 'size',
  defaultSize: 25,
  firstPage: 0,
  sendPageIfDefault: true,
};

export const DEPOSIT_PAGINATION: ServerPaginationConfig = {
  enabled: true,
  mode: 'server',
  pageParam: 'page',
  sizeParam: 'size',
  defaultSize: 25,
  firstPage: 0,
  sendPageIfDefault: true,
};

export const CASHOUT_DEPOSITS_ROUTE_PATHS = {
  cashoutDeposits: '/movements/cashout-deposits',
};

export const CASHOUT_DEPOSITS_API_PATHS = {
  cashouts: '/v1/api/platform/merchant/cashouts',
  deposits: '/v1/api/platform/merchant/deposits',
  cashoutReceipt: '/v1/api/platform/merchant/cashout',
  depositReceipt: '/v1/api/platform/merchant/deposit',
  cashoutNotification: '/v1/api/platform/merchant/cashout',
  depositNotification: '/v1/api/platform/merchant/deposit',
};
